module.exports = __webpack_public_path__ + "img/downloadSvg.c098c63d.svg";